// extracted by mini-css-extract-plugin
module.exports = {"staticHeader":"_7da85bc","header":"_e9fa10e","closeButton":"_6e8a932","backButton":"_bc3d1b2","image":"_c9696fb"};